import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export enum LuIconType {
	SOLID = 'fas',
	REGULAR = 'far',
	LIGHT = 'fal',
	BRANDS = 'fab'
}

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'lu-icon',
	templateUrl: './lu-icon.component.html',
	styleUrls: ['./lu-icon.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LuIconComponent {
	iconUrl = '';
	iconName;
	@Input() type: LuIconType = LuIconType.REGULAR;
	@Input() customClass: string;
	@Input() set icon(value: string) {
		if (!!value) {
			this.iconName = value;
			if (this.isCustomIcon(value)) {
				this.iconUrl = `${window.location.origin}/icons#${value}`;
			}
		}
	}
	private isCustomIcon(icon: string): boolean {
		return icon.split('-')[0] === 'lu';
	}
}
